module.exports = require("@nestjs/websockets");